import generalBridge from "@/plugin/generalBridge.js";
export default {
    data () {
        return {
            venueList: [],
            mealList: [],
            accommodationList: [],
            otherList: [],
            loadType: '',
            rightTxt: '询价',
            isCanEdit: true
        }
    },
    computed: {
        isCanAdd () {
            return !!(this.isCanEdit && this.rightTxt && !this.fromPage)
        },
    },
    methods: {
        async getItems() {
            this.venueList = []
            this.mealList = []
            this.accommodationList = []
            this.otherList = []
            let res = await this.$service.queryItems( {proposalId: this.$SmartStorage.get('proposalId')})
            if (res && res.success) {
                this.loadType = '';
                this.rqdata = res.content || [];
                if (this.rqdata.length) {
                    this.rqdata.forEach((ele, index) => {
                        if ([1, 5, -2,-1].includes(ele.status)) {
                            this.rightTxt = "";
                        }
                        !index && this.$SmartStorage.set('venueList', this.selectedVenue)
                        if (['ipsen'].includes(this.$cookie.get("tenant")) && ele.status == 999) {
                            this.isCanEdit = false
                        }
                        ele.key = new Date().getTime() + index
                        switch (ele.itemType) {
                            case 1:
                                this.venueList.push(ele)
                                break
                            case 2:
                                this.mealList.push(ele)
                                break
                            case 3:
                                this.accommodationList.push(ele)
                                break
                            case 4:
                                this.otherList.push(ele)
                                break
                        }
                    });
                }
            }
        },
        async getAddDemandBtn () {
            let miceInfo = this.$SmartStorage.get("eventData")
            let tenant = this.$cookie.get("tenant") || this.$cookie.get("tenant_code")
            let params = {
                collection:"cfg-ivenue-service",
                useCaching:false,
                cachingKey:"",
                filter:{
                    tenantCode: tenant,
                    "isOrder": false,
                    eventType:{"$in":[ miceInfo?.typeDictTxt || "*","*"]},
                    eventPlace:{"$in":[miceInfo?.eventPlace || "*","*"]},
                    "eventCity.city":{"$in":[miceInfo?.cityDictVal || "*","*"]}
                }
            }
            let res = await this.$service.getsettings(params)
            if (res && res.success) {
                this.demandTypeList = res.content.channels
            }
        },
        StartInquiry () {
            if (this.rightTxt != "询价") {
                return
            }
            let total = this.venueList.length + this.mealList.length + this.accommodationList.length + this.otherList.length
            if (total < 1) {
                this.$toast("请至少创建一条需求");
                return;
            }
            this.$dialog.confirm({
                title: '提示',
                message: '请确保您所有的需求都已经添加完成，一旦提交不可再增加或修改需求，请仔细确认！',
            }).then(async () => {
                let params = {
                    proposalId: this.$SmartStorage.get("proposalId"),
                    operationType: 1, // 提交报价 1，退回报价 2，退回结算3，退回损失 4
                }
                let response = await this.$service.createTask(params);
                if (response.success) {
                    this.$toast("需求提交询价成功！");
                    generalBridge.propy.call(this)
                }
            }).catch(() => {});
        }
    }
}
